export default __webpack_public_path__ + "static/media/Ies_Ledvance.8191c97c.png";